var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgDoubleCarrotUp = function SvgDoubleCarrotUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.592 12.693a1.05 1.05 0 01-1.485 0L11.95 8.535l-4.158 4.158a1.05 1.05 0 01-1.485-1.486l4.9-4.9a1.05 1.05 0 011.485 0l4.9 4.9c.41.41.41 1.075 0 1.486z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.592 18a1.05 1.05 0 01-1.485 0l-4.157-4.158-4.158 4.157a1.05 1.05 0 11-1.485-1.485l4.9-4.9a1.05 1.05 0 011.485 0l4.9 4.9c.41.41.41 1.075 0 1.485z",
    fill: "#fff"
  })));
};

export default SvgDoubleCarrotUp;